import SwiperCore, { Navigation } from 'swiper'

SwiperCore.use([Navigation])

let slider
const breakpoint = window.matchMedia( '(max-width: 640px)')
const settings = {
    direction: 'horizontal',
    watchSlidesVisibility: true,
    slidesPerView: 'auto',
    watchOverflow: true,
    slidesOffsetAfter: 150,
    freeMode: true,
}

const initSlider = () => {
    slider = new SwiperCore('.js_oraComparisonCards__slider', settings)
}

const triggerSlider = () => {
    if (breakpoint.matches) {
        if (slider !== undefined) {
            slider.destroy(true, true)
        }
    } else {
        return initSlider()
    }
}

const el = document.querySelector('.js_oraComparisonCards__slider')

if (el) {
    breakpoint.addEventListener('change', triggerSlider)
    triggerSlider()
}